var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"buzzsproutPlayer",staticClass:"buzz-sprout-player__wrapper",class:_vm.dynamicWrapperClass},[_c('div',{attrs:{"id":"buzzsprout-small-player"}})])}
var staticRenderFns = []

export { render, staticRenderFns }